// extracted by mini-css-extract-plugin
export var copyableField = "_mg-4";
export var customerBadge = "_mg-0";
export var customerInfoTitle = "_mg-2";
export var details = "_mg-1";
export var dropdownContainer = "_mg-5";
export var dropdownImage = "_mg-6";
export var editAssigneeForm = "_mg-a";
export var editButton = "_mg-3";
export var email = "_mg-7";
export var hidden = "_mg-d";
export var input = "_mg-8";
export var saveButton = "_mg-b";
export var shopifyIcon = "_mg-c";
export var suggestionBadge = "_mg-e";
export var suggestionText = "_mg-f";
export var username = "_mg-9";